// import fetch from "auth/FetchInterceptor";
import { lossClient } from "api";

const CollateralTypeService = {};
// console.log("🚀 ~ CollateralTypeService:", CollateralTypeService);

CollateralTypeService.postCollateralType = function (data) {
  return lossClient({
    url: "/CollateralType/add",
    method: "post",
    data: data,
  });
};

CollateralTypeService.getCollateralTypeList = function (userInput) {
  var userInputIndex = userInput.pageIndex || 0;
  // console.log(
  //   "🚀 ~ file: CollateralTypeService.js:17 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: CollateralTypeService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/CollateralType/search?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

CollateralTypeService.getCollateralTypeApprovalList = function (userInput) {
  var userInputIndex = userInput.pageIndex;
  // console.log(
  //   "🚀 ~ file: CollateralTypeService.js:45 ~ userInputIndex:",
  //   userInputIndex
  // );
  var decrementIndex =
    userInputIndex === 0 ? userInputIndex : userInputIndex - 1;
  // console.log(
  //   "🚀 ~ file: CollateralTypeService.js:22 ~ decrementIndex:",
  //   decrementIndex
  // );
  return lossClient({
    url:
      "/CollateralType/ApprovalItems?pageSize=" +
      userInput.pageSize +
      "&pageIndex=" +
      decrementIndex +
      "&code=" +
      userInput.code +
      "&desc=" +
      userInput.desc +
      "&status=" +
      userInput.status,
    method: "get",
  });
};

CollateralTypeService.putCollateralTypeApproval = function (data) {
  const requestDataValidation =
    data.approvalFlag.toLowerCase() == "return"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag.toLowerCase() == "reject"
      ? { UserId: data.userId, Note: data.note }
      : data.approvalFlag == "approve"
      ? { userId: data.userId, Note: data.note }
      : { UserId: data.userId, Note: data.note };

  let urlRequest;
  const requestUrlValdiation =
    data.approvalFlag.toLowerCase() == "return"
      ? (urlRequest = "return")
      : data.approvalFlag.toLowerCase() == "reject"
      ? (urlRequest = "reject")
      : data.approvalFlag == "approve"
      ? (urlRequest = "approve")
      : (urlRequest = "");

  // console.log("🚀 ~ data:", data);
  // console.log("🚀 ~ urlRequest:", urlRequest);
  // console.log("🚀 ~ requestUrlValdiation:", requestUrlValdiation);
  // console.log("🚀 ~ validData:", requestDataValidation);

  return lossClient({
    url: `/CollateralType/${urlRequest}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: requestDataValidation,
  });
};

CollateralTypeService.putCollateralTypeRequest = function (data) {
  // console.log("🚀 ~ data:", data);

  var bodyRequest = {
    Request: data.Request,
    note: data.note,
    userId: data.userId,
  };
  // console.log("🚀 ~ bodyRequest:", bodyRequest);
  return lossClient({
    url: `/CollateralType/${data.approvalFlag}`,
    method: "put",
    headers: {
      "x-requestid": data.id,
    },
    data: bodyRequest,
  });
};

CollateralTypeService.getCollateralTypeDetail = function (data) {
  return lossClient({
    url: `/CollateralType/${data.id}`,
    method: "get",
  });
};

CollateralTypeService.updateCollateralType = function (data) {
  // console.log("🚀 ~ data:", data);
  const { id, ...requestBody } = data;
  // console.log("🚀 ~ rest:", requestBody);

  return lossClient({
    url: "/CollateralType/edit",
    method: "put",
    headers: {
      "x-requestId": data.id,
    },
    data: requestBody,
  });
};

CollateralTypeService.deleteCollateralType = function (data) {
  // console.log("🚀 ~ CollateralTypeService.deleteCollateralType ~ data:", data);
  const { CollateralTypeId, ...requestBody } = data;
  // console.log("🚀 ~ requestBody:", requestBody);
  return lossClient({
    url: "/CollateralType/delete",
    method: "delete",
    headers: {
      "x-requestid": data.CollateralTypeId,
    },
    data: requestBody,
  });
};

export default CollateralTypeService;
